import React from "react";
import { useNavigate } from "react-router-dom";
import { Target, Heart, Award, Users } from "lucide-react";
import { Button } from "../components/ui/button";
import { Container, Reveal, SectionLabel } from "../components/primitives";
import Seo from "../components/Seo";

const values = [
  { icon: Target, title: "Results-driven", desc: "We design for conversions, not just looks." },
  { icon: Heart, title: "Local-first", desc: "We understand local businesses and their customers." },
  { icon: Award, title: "Premium quality", desc: "Every site is crafted to make you look established." },
  { icon: Users, title: "Real support", desc: "A dedicated team behind every project, every step." },
];

export default function About() {
  const navigate = useNavigate();
  return (
    <div data-testid="about-page" className="pt-32">
      <Seo page="about" />
      <Container>
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <SectionLabel>About</SectionLabel>
            <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold tracking-tighter text-[#F3EDDC]">
              We build websites local businesses are proud of
            </h1>
            <p className="mt-6 text-lg text-[#B7AF98] leading-relaxed">
              WebLaunch Studio is a full-service web design agency helping local businesses win online. We combine premium design, conversion strategy and reliable support to deliver websites that actually grow your business.
            </p>
            <p className="mt-4 text-[#B7AF98] leading-relaxed">
              From roofing companies to med spas, we've designed concept experiences that show how the right website turns visitors into customers. When you work with us, you get a partner invested in your growth.
            </p>
            <Button onClick={() => navigate("/contact")} className="mt-8 rounded-full bg-[#C9A227] hover:bg-[#B0891C] text-black h-12 px-7">Start your project</Button>
          </Reveal>
          <Reveal delay={120}>
            <div className="rounded-3xl overflow-hidden border border-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.12)]">
              <img src="https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="Web design team collaborating" className="w-full h-[460px] object-cover" />
            </div>
          </Reveal>
        </div>

        <div className="mt-24 grid grid-cols-2 lg:grid-cols-4 gap-6 pb-8">
          {values.map((v, i) => (
            <Reveal key={v.title} delay={i * 60}>
              <div className="rounded-2xl border border-white/10 bg-[#141414] p-7 h-full">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#C9A227]/10 text-[#C9A227]"><v.icon className="h-5 w-5" /></div>
                <h3 className="mt-5 font-display text-lg font-semibold text-[#F3EDDC]">{v.title}</h3>
                <p className="mt-2 text-sm text-[#B7AF98]">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="my-24 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {[["500+", "Projects delivered"], ["72h", "Avg. delivery"], ["4.9/5", "Client rating"], ["98%", "Would recommend"]].map(([v, l]) => (
            <div key={l}>
              <div className="font-display text-4xl font-bold text-[#F3EDDC]">{v}</div>
              <div className="mt-1 text-sm text-[#948C79]">{l}</div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}
